import { BlueprintsStore } from "imagica-corekit/dist/base/store/BlueprintsStore";
import { Container } from "inversify";
import { PersonalFunctionStore } from "imagica-corekit/dist/base/store/PersonalFunctionStore";
import { CookieStorageManagerImpl } from "@infra/CookieStorageManagerImpl";
import { FunctionV2Store } from "imagica-corekit/dist/base/store/FunctionV2Store";
import { UiFunctionService } from "@uikit/service/UiFunctionService";
import { CorekitRegistry, CorekitRegistryParams } from "imagica-corekit/dist/registry/CorekitRegistry";
import { ServiceIdentifier } from "imagica-corekit/dist/base/cutil/ServiceIdentifier";
import { ToolPieceStore } from "imagica-corekit/dist/base/store/ToolPieceStore";
import { LocalStorageManagerImpl } from "imagica-corekit/dist/infra/LocalStorageManagerImpl";
import { LocationManagerImpl } from "imagica-corekit/dist/infra/LocationManagerImpl";
import { ChatAIStore } from "@uiview/views/ChatAI/ChatAIStore";
import { HomePluginStore } from "imagica-corekit/dist/base/store/HomePluginStore";
import { PreviewPaneStore } from "@uiview/views/PreviewPane/PreviewPaneStore";
import { HomeStore } from "imagica-corekit/dist/cases/store/HomeStore";
import { ProjectNetDataStore } from "@base/ProjectNetDataStore";
import { MeStore } from "imagica-corekit/dist/base/store/MeStore";
import { Analytics } from "imagica-corekit/dist/base/port/Analytics";
import { AnalyticsImpl } from "@infra/AnalyticsImpl";
import { CreatorAISaasStore } from "@uiview/views/ProjectCanvas/store/CreatorAISassStore";
import { NavBarStore } from "@uiview/views/navBar/NavBarStore";
import store from "@store/index";
import { ObjectRelationGqlService } from "@uikit/service/ObjectRelationGqlService";
import { CreatorSaasAppStore } from "@uiview/views/ProjectCanvas/store/CreatorSaasAppStore";
import { CreateService } from "@uikit/service/CreateService";
import { PreviewAppStore } from "@uiview/views/ProjectCanvas/store/PreviewAppStore";
import { ChatOnboardingStore } from "imagica-corekit/dist/cases/chatOnboarding/ChatOnboarding";
import { CreatorNodesStore } from "@uiview/views/ProjectCanvas/store/CreatorNodesStore";
import { CreatorEdgesStore } from "@uiview/views/ProjectCanvas/store/CreatorEdgesStore";
import { HomeMethodsService } from "@uikit/service/HomeMethodsService";
import { creatorRefStore } from "@uiview/views/ProjectCanvas/store/CreatorRefStore";
import { previewStore } from "@uiview/store/PreviewStore";
import { CanvasDataRef } from "@uikit/model/CanvasDataRef";
import { SaveTemplateService } from "@uikit/service/SaveTemplateService";
import { myModificationDataStroe } from "@uiview/views/ProjectCanvas/store/MyModificationDataStroe";
import { functionPopupStore } from "@uiview/views/ProjectCanvas/store/FunctionPopupStore";
import { showNavPageStore } from "@uiview/views/HomeRoot/store/ShowNavPageStore";
import { FotSaveService } from "@uikit/service/FotSaveService";
import { homeToolBarStore } from "@uiview/views/ProjectCanvas/store/homeToolBarStore";
import { FotSaveEvent } from "@uikit/service/FotSaveEvent";
import { SaveCore } from "imagica-corekit/dist/cases/saveService/SaveCore";
import { SaveCreateService } from "imagica-corekit/dist/cases/saveService/SaveCreateService";
import { WindowSizeStore } from "@uikit/store/WindowSizeStore";
import { FotReduxStore } from "@uikit/store/FotReduxStore";
import { FotUserAuthService } from "@uikit/service/FotUserAuthService";
import { FotProcessStore } from "@uikit/store/FotProcessStore";
import { ViewbuilderStore } from "imagica-corekit/dist/cases/store/ViewbuilderStore";
import { ProjectLoader } from "@uikit/fotProcess/ProjectLoader";
import { ProjectStore } from "imagica-corekit/dist/base/store/ProjectStore";
import { customFunctionStore } from "@uiview/views/ProjectCanvas/store/CustomFunctionStore";
import { CreatorStoreMethods } from "@uikit/service/CreatorStoreMethods";
import { CreateProjectService } from "@uikit/service/CreateProjectService";
import { ProjectNodeStore } from "@uikit/projectNode/ProjectNodeStore";

export class InjectConfig {
  private static container?: Container;

  static get<T>(serviceIdentifier: ServiceIdentifier<T>): T {
    return InjectConfig.configure().get<T>(serviceIdentifier);
  }

  private static configure(): Container {
    if (InjectConfig.container != null) {
      return InjectConfig.container;
    }
    const container = new Container({
      autoBindInjectable: true,
      defaultScope: "Singleton",
      skipBaseClassChecks: true,
    });
    InjectConfig.container = container;
    InjectConfig.before(container);
    const params: CorekitRegistryParams = {
      cookieStorageManager: new CookieStorageManagerImpl(),
      defaultStorageManager: new LocalStorageManagerImpl(),
      locationManager: new LocationManagerImpl(),
      location: window.location.href,
    };
    CorekitRegistry.configure(container, params);
    InjectConfig.after(container);

    console.log("InjectConfig complete");
    return container;
  }

  private static before(container: Container): void {
    container.bind(Analytics).toConstantValue(new AnalyticsImpl());
  }

  /**
   *
   * @param {Container} container
   * @param {CorekitRegistryParams} params
   */
  private static after(container: Container): void {
    const it = <T>(serviceIdentifier: ServiceIdentifier<T>): T => {
      return container.get(serviceIdentifier);
    };

    const fotReduxStore = new FotReduxStore(store);
    const chatAIStore = new ChatAIStore();
    const homePluginStore = new HomePluginStore();
    const projectDataStore = new ProjectNetDataStore(it(MeStore));
    const fotHomeStore = new HomeStore();
    const previewPaneStore = new PreviewPaneStore();
    const creatorAISassStore = new CreatorAISaasStore(store);
    const navBarStore = new NavBarStore();
    const objectRelationGqlService = new ObjectRelationGqlService();
    const windowSizeStore = new WindowSizeStore();
    const creatorNodesStore = new CreatorNodesStore();
    const creatorEdgesStore = new CreatorEdgesStore();
    const creatorSaasAppStore = new CreatorSaasAppStore(creatorNodesStore);
    const projectNodeStore = new ProjectNodeStore();

    const homeMethodsService = new HomeMethodsService(
      store,
      creatorNodesStore,
      creatorEdgesStore,
      creatorRefStore,
      homePluginStore,
      creatorAISassStore,
      creatorSaasAppStore,
      previewStore,
      projectNodeStore
    );
    const previewAppStore = new PreviewAppStore(
      fotReduxStore,
      creatorSaasAppStore,
      previewStore,
      it(ChatOnboardingStore),
      creatorRefStore,
      creatorNodesStore,
      previewPaneStore,
      it(ViewbuilderStore),
      creatorAISassStore,
      fotHomeStore,
      projectNodeStore
    );

    const fotSaveEvent = new FotSaveEvent(store, previewAppStore, homePluginStore);
    const createService = new CreateService(
      store,
      objectRelationGqlService,
      it(PersonalFunctionStore),
      it(SaveCreateService),
      fotSaveEvent
    );

    const canvasDataRef = new CanvasDataRef(creatorRefStore, creatorNodesStore);
    const saveTemplateService = new SaveTemplateService(
      store,
      creatorEdgesStore,
      myModificationDataStroe,
      functionPopupStore,
      createService,
      creatorRefStore,
      objectRelationGqlService,
      showNavPageStore,
      homeMethodsService,
      creatorNodesStore,
      canvasDataRef,
      it(PersonalFunctionStore)
    );
    const projectLoader = new ProjectLoader(
      fotReduxStore,
      it(ProjectStore),
      previewStore,
      creatorSaasAppStore,
      creatorAISassStore,
      previewAppStore,
      fotHomeStore,
      creatorRefStore,
      canvasDataRef,
      homeToolBarStore,
      creatorNodesStore,
      creatorEdgesStore,
      customFunctionStore,
      projectNodeStore
    );
    const handleSaveService = new FotSaveService(
      creatorEdgesStore,
      creatorNodesStore,
      homeMethodsService,
      previewAppStore,
      canvasDataRef,
      creatorRefStore,
      myModificationDataStroe,
      homeToolBarStore,
      previewStore,
      fotSaveEvent,
      it(SaveCore)
    );

    const fotUserAuthService = new FotUserAuthService(
      fotReduxStore,
      it(MeStore),
      objectRelationGqlService,
      homePluginStore,
      fotHomeStore
    );
    const fotProcessStore = new FotProcessStore();
    const createProjectService = new CreateProjectService(
      fotReduxStore,
      creatorNodesStore,
      creatorEdgesStore,
      previewAppStore,
      creatorRefStore,
      canvasDataRef
    );

    const creatorStoreMethods = new CreatorStoreMethods(
      fotReduxStore,
      homePluginStore,
      homeMethodsService,
      creatorNodesStore,
      creatorEdgesStore,
      creatorRefStore,
      homeToolBarStore,
      customFunctionStore
    );
    container.bind(FotSaveEvent).toConstantValue(fotSaveEvent);
    container.bind(ChatAIStore).toConstantValue(chatAIStore);
    container.bind(HomePluginStore).toConstantValue(homePluginStore);
    container.bind(HomeStore).toConstantValue(fotHomeStore);
    container.bind(PreviewPaneStore).toConstantValue(previewPaneStore);
    container.bind(ProjectNetDataStore).toConstantValue(projectDataStore);
    container.bind(CreatorAISaasStore).toConstantValue(creatorAISassStore);
    container
      .bind(UiFunctionService)
      .toConstantValue(
        new UiFunctionService(it(FunctionV2Store), it(PersonalFunctionStore), it(ToolPieceStore), it(BlueprintsStore))
      );
    container.bind(NavBarStore).toConstantValue(navBarStore);
    container.bind(ObjectRelationGqlService).toConstantValue(objectRelationGqlService);
    container.bind(CreatorSaasAppStore).toConstantValue(creatorSaasAppStore);
    container.bind(CreateService).toConstantValue(createService);
    container.bind(CreatorNodesStore).toConstantValue(creatorNodesStore);
    container.bind(CreatorEdgesStore).toConstantValue(creatorEdgesStore);
    container.bind(HomeMethodsService).toConstantValue(homeMethodsService);
    container.bind(PreviewAppStore).toConstantValue(previewAppStore);
    container.bind(CanvasDataRef).toConstantValue(canvasDataRef);
    container.bind(SaveTemplateService).toConstantValue(saveTemplateService);
    container.bind(FotSaveService).toConstantValue(handleSaveService);
    container.bind(WindowSizeStore).toConstantValue(windowSizeStore);
    container.bind(FotReduxStore).toConstantValue(fotReduxStore);
    container.bind(FotUserAuthService).toConstantValue(fotUserAuthService);
    container.bind(FotProcessStore).toConstantValue(fotProcessStore);
    container.bind(ProjectLoader).toConstantValue(projectLoader);
    container.bind(CreatorStoreMethods).toConstantValue(creatorStoreMethods);
    container.bind(CreateProjectService).toConstantValue(createProjectService);
    container.bind(ProjectNodeStore).toConstantValue(projectNodeStore);
  }
}
